import { render } from "./questionTwo.vue?vue&type=template&id=6ea24084"
import script from "./questionTwo.vue?vue&type=script&lang=ts"
export * from "./questionTwo.vue?vue&type=script&lang=ts"

import "./questionTwo.vue?vue&type=style&index=0&id=6ea24084&lang=css"
script.render = render

export default script